import React from 'react'
import { useTranslation } from 'react-i18next'

import { PageSubheadline } from '@components/typography/page_subheadline'
import { SectionHeadline } from '@components/typography/section_headline'
import { SectionSubheadline } from '@components/typography/section_subheadline'

import styles from '@components/pages/sms/sms_header.module.scss'

const SmsHeader = () => {
  const { t } = useTranslation()

  return (
    <div className="page__plain__header">
      <PageSubheadline>{t('sms.headerTitle')}</PageSubheadline>
      <SectionHeadline classes={styles.sms_header__section_headline}>
        {t('sms.headerSubtitle')}
      </SectionHeadline>
      <SectionSubheadline classes="margin-top-1">{t('sms.headerText')}</SectionSubheadline>
    </div>
  )
}

export { SmsHeader }
